import { gql } from "config/graphql";
import { gqlQuery } from "store/apollo";

interface IResponse {
  data: {
    translations: {
      key: string;
      value: string;
    }[];
  };
}

export const translationsQuery = async (): Promise<IResponse> => {
  const query = gql`
    query translations {
      translations(slug: "web") {
        key
        value
      }
    }
  `;

  return gqlQuery<IResponse["data"]>({
    fetchPolicy: "cache-first",
    query,
  });
};
